/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import Slider from 'react-slick';
import {
  cardContenttype,
  cardDataExtractorUtil,
  mutvslideShowCount,
  checkIsFeatured,
} from './mutvutil';
import {
  PrevArrow,
  NextArrow,
  afterChangeAccessbility,
  beforeChangeAccessbility,
  onInitAccessibility,
  slideShowCount,
  featuredShowCount,
} from '../../utils/carouselUtils';
import MutvCards from './Cards/MutvCards';
import { nextPrevArrow } from '../../utils/utils';
import MU from '../../constants/muConstants';
const MutvSliderCarousel = ({
  isTouchDevice,
  refCallBack,
  data,
  isTrending,
  aspectRatio,
  contentType,
  isDiscover,
  isUserLogin,
  isGigyaAvilable,
  userLoginDetail,
  isLoginChecked,
  isUserSubscribe,
  isUserSkyId,
  dispatch,
  featurecardType,
  isFeatureCard,
}) => {
  const [slicker, setSlicker] = useState({});
  const [screenReaderText, setScreenReaderText] = useState('');
  const slideCount = () => {
    if (data && data.length > 0) {
      return data.length;
    } else {
      return 0;
    }
  };
  const setScreenReaderValue = (index) => {
    const a = index;
    const b = slideShowCounter(aspectRatio);
    const c = slideCount();
    if (a + b <= c) {
      setScreenReaderText(`Displayed ${a + 1} of ${a + b} out of ${c}`);
    }
    setTimeout(() => {
      setScreenReaderText('');
    }, 300);
  };
  const slideShowCounter = (aspectRatio, carouselContentType) => {
    if (isDiscover) {
      return slideShowCount();
    } else if (featurecardType && checkIsFeatured(carouselContentType, featurecardType)) {
      return featuredShowCount(featurecardType);
    } else {
      if (aspectRatio) {
        if (aspectRatio === '3x4') {
          return slideShowCount();
        } else {
          return mutvslideShowCount();
        }
      } else if (carouselContentType === 'continuelistening') {
        return mutvslideShowCount();
      } else {
        return slideShowCount();
      }
    }
  };

  const settings = (res, carouselContentType) => {
    const aspectRatioCheck = res;
    return {
      dots: true,
      infinite: false,
      //adaptiveHeight: true,
      speed: 400,
      className: 'carousal-list center',
      lazyLoad: 'progressive',
      slidesToScroll: slideShowCounter(aspectRatioCheck, carouselContentType),
      swipe: true,
      accessibility: false,
      slidesToShow: slideShowCounter(aspectRatioCheck, carouselContentType),
      touchMove: true,
      mobileFirst: true,
      touchThreshold: 20,
      initialSlide: 0,
      rtl: false,
      arabic: MU.language === 'ar' ? true : false,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow slideShow={slideShowCounter(aspectRatioCheck, carouselContentType)} />,
      draggable: false,
      // swipeToSlide: true,
      variableWidth: true,
      onInit: (e) => {
        // if (e.includes(slideCount() - 1)) {}
        const element = refCallBack();
        if (element) {
          const slider = element && element.current;
          let list = slider && slider.querySelector('.slick-list');
          let slideTrack = list && list.querySelector('.slick-track');
          let slides = slideTrack && slideTrack.querySelectorAll('.slick-slide');
          let nextArrow = slider && slider.querySelector('.slider-next.slick-arrow');
          let prevArrow = slider && slider.querySelector('.slider-prev.slick-arrow');
          onInitAccessibility(slideTrack, slides, 'MUTV');
          setSlicker({
            slider: slider,
            list: list,
            track: slideTrack,
            slides: slides,
            nextArrow: nextArrow,
            prevArrow: prevArrow,
          });
        }
      },
      beforeChange: (oldIndex, newIndex) => {
        setScreenReaderValue(newIndex);
        nextPrevArrow(oldIndex, newIndex, slicker);
        beforeChangeAccessbility(slicker, 'mutv');
      },
      afterChange: () => {
        afterChangeAccessbility(slicker);
      },
      appendDots: (dots) => {
        if (dots && dots.length) {
          let isActive = true;
          let list = dots.map((val, index) => {
            isActive = isActive ? val.props.className !== 'slick-active' : false;
            return (
              <li key={index} className={`${val.props.className} ${isActive ? 'active' : ''}`}>
                <i></i>
              </li>
            );
          });
          return (
            <div className="slick-dots">
              <ul tabIndex="-1" aria-hidden="true">
                {list}
              </ul>
            </div>
          );
        }
      },
    };
  };
  const renderCards = (aspectRatio, index, isTrending, carouselContentType, item) => {
    if (cardContenttype.includes(item.contenttype_t && item.contenttype_t.toLowerCase())) {
      return (
        <React.Fragment>
          {item && (
            <MutvCards
              cardAspectRatio={aspectRatio}
              trending={isTrending}
              trendingIndex={isTrending ? index + 1 : null}
              carouselContentType={carouselContentType}
              isDiscover={isDiscover}
              key={index}
              item={item}
              isCarousal={true}
              isUserLogin={isUserLogin}
              isGigyaAvilable={isGigyaAvilable}
              userLoginDetail={userLoginDetail}
              isLoginChecked={isLoginChecked}
              dispatch={dispatch}
              gridClass={'grid-3'}
              featurecardType={featurecardType}
              isFeatureCard={isFeatureCard}
              isUserSubscribe={isUserSubscribe}
              isUserSkyId={isUserSkyId}
              isContinueCard={carouselContentType === 'continuelistening' ? true : false}
            />
          )}
        </React.Fragment>
      );
    } else {
      return null;
    }
  };
  const renderMobileView = () => {
    return (
      <React.Fragment>
        <div className={`carousal-list custom-mobile-slider`}>
          {data.map((item, index) => {
            return (
              <div className="mobile-listitem" role="listitem" key={index}>
                {renderCards(aspectRatio, index, isTrending, contentType, item)}
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };

  const rednerDesktopView = (data, index) => {
    return (
      <React.Fragment>
        {data && data.length && (
          <Slider {...settings(aspectRatio, contentType)}>
            {data.map((item, index) => {
              return renderCards(aspectRatio, index, isTrending, contentType, item);
            })}
          </Slider>
        )}
      </React.Fragment>
    );
  };
  return (
    <React.Fragment>
      {data && data.length > 0 && (
        <div>
          {!isTouchDevice && rednerDesktopView(data)}
          {isTouchDevice && renderMobileView()}
          {!isTouchDevice && (
            <div className="screenreader" aria-live="assertive">
              {screenReaderText}
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(MutvSliderCarousel);
